<template>
  <div class="about">
    <component :is="component" />
  </div>
</template>
<script>
import Balai from './components/Balai';
import Direktorat from './components/Direktorat';
import { mapState } from 'vuex';

export default {
  name: 'LaporanIhtBalai',
  components: { Balai, Direktorat },
  computed: {
    ...mapState('preferensi', {
      instansi: (state) => state.data?.instansi ?? {},
    }),

    component() {
      if (+this.instansi.k_jenis_instansi === 18) {
        return 'Direktorat';
      }

      return 'Balai';
    },
  },
};
</script>
